import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getMortarElectricTrend } from '@/service/production/ProReportMortar';
export default function useProDataTrend(params) {
  var mortarElectircTrend = ref([]);
  var mortarElectircYearTrend = ref([]);
  // 获取主机汇总数据
  var getMortarElectricTrendAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var num, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            num = 30;
            _context.t0 = params.value.type;
            _context.next = _context.t0 === 0 ? 4 : _context.t0 === 1 ? 6 : _context.t0 === 2 ? 8 : _context.t0 === 3 ? 10 : _context.t0 === 4 ? 12 : 14;
            break;
          case 4:
            num = 30;
            return _context.abrupt("break", 14);
          case 6:
            num = 30;
            return _context.abrupt("break", 14);
          case 8:
            num = 12;
            // num = 30
            return _context.abrupt("break", 14);
          case 10:
            num = 3;
            // num = 12
            return _context.abrupt("break", 14);
          case 12:
            num = 10;
            return _context.abrupt("break", 14);
          case 14:
            _context.next = 16;
            return getMortarElectricTrend(_objectSpread(_objectSpread({}, params.value), {}, {
              rangeType: params.value.type,
              rangeNum: num
            }));
          case 16:
            data = _context.sent;
            mortarElectircTrend.value = data.list;
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getMortarElectricTrendAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var getMortarElectricYearTrendAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getMortarElectricTrend({
              type: 3,
              date: params.value.date,
              rangeType: -1,
              rangeNum: 3
            });
          case 2:
            data = _context2.sent;
            mortarElectircYearTrend.value = data.list;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getMortarElectricYearTrendAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  return [mortarElectircTrend, mortarElectircYearTrend, getMortarElectricTrendAsync, getMortarElectricYearTrendAsync];
}